import { toPath } from "./path.js";
/**
 * Unchecked version of {@link defGetter}.
 *
 * @remarks
 * The type parameter `T` can be used to indicate the type of the nested
 * value to be retrieved (default: `any`).
 *
 * Also see: {@link getIn}, {@link getInUnsafe}
 *
 * @example
 * ```ts
 * const g = defGetterUnsafe("a.b.c");
 *
 * g({ a: { b: { c: 23} } }) // 23
 * g({ x: 23 }) // undefined
 * g() // undefined
 * ```
 *
 * @param path -
 */
export const defGetterUnsafe = (path) => defGetter(path);
export function defGetter(path) {
    const ks = toPath(path);
    const [a, b, c, d] = ks;
    switch (ks.length) {
        case 0:
            return (s) => s;
        case 1:
            return (s) => (s != null ? s[a] : undefined);
        case 2:
            return (s) => s != null ? ((s = s[a]) != null ? s[b] : undefined) : undefined;
        case 3:
            return (s) => s != null
                ? (s = s[a]) != null
                    ? (s = s[b]) != null
                        ? s[c]
                        : undefined
                    : undefined
                : undefined;
        case 4:
            return (s) => s != null
                ? (s = s[a]) != null
                    ? (s = s[b]) != null
                        ? (s = s[c]) != null
                            ? s[d]
                            : undefined
                        : undefined
                    : undefined
                : undefined;
        default:
            return (s) => {
                const n = ks.length - 1;
                let res = s;
                for (let i = 0; res != null && i <= n; i++) {
                    res = res[ks[i]];
                }
                return res;
            };
    }
}
